// extracted by mini-css-extract-plugin
export default {"line":"AddressForm_line__IAEyt","subheading":"AddressForm_subheading__4e6xG","recaptcha":"AddressForm_recaptcha__qFOFN"};